import Image from 'next/image';

import { AttachmentIcon } from '@chakra-ui/icons';
import { Flex, Tag, Text } from '@chakra-ui/react';
import { AiTwotoneCalendar } from 'react-icons/ai';
import { HiOutlineTag } from 'react-icons/hi';

import useTranslation from 'next-translate/useTranslation';
import { configFile } from '@/config';

export default function Ativity() {
  const { t } = useTranslation('services');

  return (
    <Flex bgColor={configFile.tertiaryAccentColor} p="24px" borderRadius="12px" direction="column" gap="6px">
      <Text mb="6px">{t('seoConsulting.agileMethods.activity')}</Text>
      <Flex color="gray.400" gap="7px">
        <AiTwotoneCalendar />
        <Text fontSize="12px" color="gray.400">
          {t('seoConsulting.agileMethods.date')}
        </Text>
      </Flex>
      <Flex color="gray.400" justifyContent="space-between">
        <Flex gap="7px">
          <HiOutlineTag />
          <Text fontSize="12px" color="gray.400">
            {t('seoConsulting.agileMethods.tags')}
          </Text>
        </Flex>
        <AttachmentIcon />
      </Flex>
      <Flex mt="27px" justifyContent="space-between" alignItems="center">
        <Image src="/images/agile-methods/people.png" alt="Ícone de pessoas" width={76} height={34} />
        <Flex gap="4px">
          <Tag bgColor="#F46A6A" color="white" borderRadius="9999px" fontSize="9px">
            A
          </Tag>
          <Tag bgColor="#F46A6A" color="white" borderRadius="9999px" fontSize="9px">
            A
          </Tag>
          <Tag bgColor="gray.200" color="gray.700" borderRadius="9999px" fontSize="9px">
            {t('seoConsulting.agileMethods.waiting')}
          </Tag>
        </Flex>
      </Flex>
    </Flex>
  );
}
